export default {
  // Textos específicos de Period
  start: 'Inicio',
  end: 'Término',
  weeks: 'Semanas',
  closeSections: 'Cierre de Secciones',
  startDateValidation: 'Este campo es obligatorio y no puede ser igual o mayor que la fecha de término.',
  endDateValidation: 'Este campo es obligatorio y no puede ser igual o menor que la fecha de inicio.',
  closeSectionsDateValidation: 'Este campo no puede ser menor que la fecha de termino.',
  weeksValidation: 'Este campo debe ser un entero mayor a cero.',
  noOverlappingValidation: 'No puede contener otro periodo dentro del rango asignado.',
  notFound: 'No se ha encontrado ningún {entity}.',
  saving: 'Guardando...',
  updating: 'Actualizando...',
  pleaseWaitSaving: 'Por favor, espera mientras se guarda la información.',
  pleaseWaitUpdating: 'Por favor, espera mientras se actualiza la información.',
  errorCreating: 'Hubo un problema al crear el período.',
  errorUpdating: 'Hubo un problema al actualizar el período.',
}
